module.exports = __webpack_public_path__ + "img/user_logo.e1ebee69.png";